import { createFileRoute } from "@tanstack/react-router";
import { QaPage, qaJsonLd } from "@/components/QaPage";
import { breadcrumbJsonLd } from "@/lib/seo-jsonld";
import { LAST_REVIEWED } from "@/lib/official-sources";

const QUESTION = "Vilka räknas till PBI-kretsen?";
const SHORT_ANSWER = "Ägare med betydande inflytande (oftast >10–20%), styrelseledamöter, VD, firmatecknare och i vissa fall finansiärer eller hyresvärdar med stark koppling.";

export const Route = createFileRoute("/fraga/vilka-rakas-till-pbi-kretsen")({
  component: () => (
    <QaPage
      breadcrumbs={[
        { label: "Hem", to: "/" },
        { label: "Frågor & svar", to: "/fraga" },
        { label: "Vilka räknas till PBI-kretsen" },
      ]}
      question={QUESTION}
      shortAnswer={SHORT_ANSWER}
      body={"Det är inte enbart ägarandel utan reellt inflytande som styr. En person med liten formell andel men stort faktiskt inflytande räknas in. Kommunen prövar alla i kretsen individuellt."}
      source={{ label: "Folkhälsomyndigheten – Serveringstillstånd (vägledning)", href: "https://www.folkhalsomyndigheten.se/livsvillkor-levnadsvanor/alkohol-narkotika-dopning-tobak-och-spel-andts/tillsynsvagledning-enligt-alkohollagen/serveringstillstand/" }}
      extraSources={[]}
      deepGuide={{ to: "/pbi-krets", label: "Vilka räknas till PBI-kretsen" }}
      related={[{"to": "/fraga/vad-galler-for-finansierare-av-verksamhet", "label": "Räknas finansiärer in i PBI-kretsen?"}, {"to": "/fraga/nar-bedoms-ekonomisk-lamplighet", "label": "Hur bedöms ekonomisk lämplighet?"}, {"to": "/fraga/vad-betyder-pbi", "label": "Vad betyder PBI?"}]}
      lastReviewed={LAST_REVIEWED}
    />
  ),
  head: () => ({
    meta: [
      { title: "Vilka räknas till PBI-kretsen?" },
      { name: "description", content: "Ägare med betydande inflytande (oftast >10–20%), styrelseledamöter, VD, firmatecknare och i vissa fall finansiärer eller hyresvärdar med stark koppling." },
      { property: "og:title", content: QUESTION },
      { property: "og:description", content: SHORT_ANSWER },
      { property: "og:url", content: "https://alkoholprovet.se/fraga/vilka-rakas-till-pbi-kretsen" },
    ],
    links: [{ rel: "canonical", href: "https://alkoholprovet.se/fraga/vilka-rakas-till-pbi-kretsen" }],
    scripts: [
      qaJsonLd({
        url: "https://alkoholprovet.se/fraga/vilka-rakas-till-pbi-kretsen",
        question: QUESTION,
        answer: SHORT_ANSWER,
      }),
      breadcrumbJsonLd([
        { label: "Hem", url: "https://alkoholprovet.se/" },
        { label: "Frågor & svar", url: "https://alkoholprovet.se/fraga" },
        { label: "Vilka räknas till PBI-kretsen", url: "https://alkoholprovet.se/fraga/vilka-rakas-till-pbi-kretsen" },
      ]),
    ],
  }),
});
